module.exports = __webpack_public_path__ + "static/Chicory3-2435e1f046ced0078572092fc840b906.png";